import { render, staticRenderFns } from "./xyk.vue?vue&type=template&id=384df572&scoped=true"
import script from "./xyk.vue?vue&type=script&lang=js"
export * from "./xyk.vue?vue&type=script&lang=js"
import style0 from "./xyk.vue?vue&type=style&index=0&id=384df572&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384df572",
  null
  
)

export default component.exports